//点击图片放大预览
import $ from "./jquery.js";
// import { Loading ,Message} from "element-ui";
//src:图片路径
const previewImg = {
	loading: null,
	init(src) {
		if(src) {
// 			this.loading = Loading.service({
// 				lock: true,
// 				text: '图片加载中,请稍后...',
// 				spinner: 'el-icon-loading',
// 				background: 'rgba(0, 0, 0, 0.1)',
// //				customClass:""
// 			});
			this.preview_img(src);
			//			
		}
	},
	//点击图片进行预览
	preview_img(src) {
		// console.log(src)
		if(src) {
			src = src.replace("(","%28").replace(")","%29");
			let that = this;
			let $img = $("<img>").attr("src", src).hide().appendTo("body");
			$img[0].onload = function() {
				let w = $img.width();
				let h = $img.height();
				let _w = w;
				let _h = h;
				if(_h>600 || _w>800){
					_h = 600;
					_w = 600 * w / h;
					if(_w > 800) {
						_w = 800;
						_h = 800 * h / w;
					}
				}
				$img.remove();
				// that.loading.close();
				// that.loading = null;
				
				let html = '<button type="button" onclick="var $this = $(this).parents(\'.preview_img\');$this.fadeOut(function(){$this.remove();})" style="z-index:100;font-size: 35px;position: absolute;right: 0px;top: 0px; " class="el-dialog__headerbtn"><i class="el-dialog__close el-icon el-icon-close"></i></button>' +
					'<div oncontextmenu="return false" onselectstart="return false" style="width:' + _w + 'px;height:' + _h + 'px;position:absolute;top:50%;transform:rotate(0deg);left:50%;margin-left:-' + _w / 2 + 'px;margin-top:-' + _h / 2 + 'px;text-align:center;background:url(' + src + ') no-repeat 0 0;background-size:100% 100%;box-shadow: 0 0 20px #000;" class="photoimg"></div><div class="el-image-viewer__btn el-image-viewer__actions"><div id="leftRotate" class="el-image-viewer__actions__inner"><i class="el-icon-refresh-left" style="cursor: pointer;"></i></div><div id="rightRotate" class="el-image-viewer__actions__inner"><i class="el-icon-refresh-right" style="cursor: pointer;"></i></div></div>';
				let div = $("<div>", {
					"class": "preview_img"
				}).css({
					"position": "fixed",
					"width": "100%",
					"height": "100%",
					"top": "0",
					"left": "0",
					"z-index": "9999999",
					"display": "none",
					"background": "rgba(0, 0, 0,0.4)"
				}).html(html).appendTo("body").fadeIn();
				div.on("click",function(e){
					if($(e.target).hasClass('preview_img')){
						$(e.target).fadeOut(function(){$(e.target).remove();})
					}
				})
				that.ScaleMovePic(div.children("div")[0], w / h);

				//获取元素transform旋转度
				$('#rightRotate').on('click',function () {
					let photoimg = $('.photoimg');
					let st = window.getComputedStyle(document.getElementsByClassName("photoimg")[0])
					let tr = st.getPropertyValue("-webkit-transform") ||
					st.getPropertyValue("-moz-transform") ||
					st.getPropertyValue("-ms-transform") ||
					st.getPropertyValue("-o-transform") ||
					st.getPropertyValue("transform") ||
					"FAIL"
				  let values = tr.split('(')[1].split(')')[0].split(',');
				  let a = values[0];
				  let b = values[1];
				  let angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));
					photoimg.css({'transform':'rotate('+(angle+90)+'deg)'});
				})

				$('#leftRotate').on('click',function () {
					let photoimg = $('.photoimg');
					let st = window.getComputedStyle(document.getElementsByClassName("photoimg")[0])
					let tr = st.getPropertyValue("-webkit-transform") ||
					st.getPropertyValue("-moz-transform") ||
					st.getPropertyValue("-ms-transform") ||
					st.getPropertyValue("-o-transform") ||
					st.getPropertyValue("transform") ||
					"FAIL"
				
				  let values = tr.split('(')[1].split(')')[0].split(',')
				  let a = values[0]
				  let b = values[1]
				  let angle = Math.round(Math.atan2(b, a) * (180 / Math.PI))
					photoimg.css({'transform':'rotate('+(angle+(-90))+'deg)'})
				})
			}
			$img[0].onerror = function(){
				$img.remove();
				that.loading.close();
				that.loading = null;
				// Message({
			  //       message: "图片加载失败",
			  //       type: "error"
			  //     });
			}
		}
		
		
	},
	//放大移动图片
	//myimage:图片背景元素
	//scale:宽高比
	ScaleMovePic(myimage, scale) {
		if(myimage.addEventListener) {
			// IE9, Chrome, Safari, Opera
			myimage.addEventListener("mousewheel", MouseWheelHandler, false);
			// Firefox
			myimage.addEventListener("DOMMouseScroll", MouseWheelHandler, false);
		}
		let bool = true;
		let w_speed = 100;

		function MouseWheelHandler(e) {

			e = e || window.event;
			if(e.stopPropagation) { //这是取消冒泡
				e.stopPropagation();
			} else {
				e.cancelBubble = true;
			}
			if(e.preventDefault) { //这是取消默认行为，要弄清楚取消默认行为和冒泡不是一回事
				e.preventDefault();
			} else {
				e.returnValue = false;
			}

			if(!bool) {
				return false;
			}

			let mydivWidth = parseInt(myimage.style.width);
			let mydivHeight = parseInt(myimage.style.height);

			let marLeft = parseInt($(myimage).css('left'));
			let marTop = parseInt($(myimage).css('top'));
			let open = true;
			let sum = 1;
			let x = e.offsetX,
				y = e.offsetY;

			if(e.wheelDelta) {

				open = e.wheelDelta > 0 ? true : false;
			} else if(e.detail) {

				open = e.detail > 0 ? true : false;
			} else {

				open = e.deltaY > 0 ? true : false;
			}
			if(!open) { //缩小
				if(mydivWidth < 300 || mydivHeight < 200) {
					bool = true;
					return false;
				}
				$(myimage).animate({
					"width": (mydivWidth - w_speed) + "px",
					"height": (mydivHeight - (w_speed / scale)) + "px",
					"left": (marLeft + (w_speed / 2) * x / (mydivWidth / 2)) + "px",
					"top": (marTop + (w_speed / scale / 2) * y / (mydivHeight / 2)) + "px"
				}, 20, function() {
					bool = true;
				})
			} else { //放大
				$(myimage).animate({
					"width": (mydivWidth + w_speed) + "px",
					"height": (mydivHeight + (w_speed / scale)) + "px",
					"left": (marLeft - (w_speed / 2 * x / (mydivWidth / 2))) + "px",
					"top": (marTop - (w_speed / scale / 2) * y / (mydivHeight / 2)) + "px"
				}, 20, function() {
					bool = true;
				})
			}
			return false;
		}

		myimage.onmousedown = function(ev) {
			let e = window.event || ev;
			//var Mydiv=document.getElementById("div");
			//获取到鼠标点击的位置距离div左侧和顶部边框的距离；
			let oX = e.clientX - parseInt($(myimage).css('left'));
			let oY = e.clientY - parseInt($(myimage).css('top'));
			//当鼠标移动，把鼠标的偏移量付给div
			document.onmousemove = function(ev) {
				//计算出鼠标在XY方向上移动的偏移量，把这个偏移量加给DIV的左边距和上边距，div就会跟着移动
				let e = window.event || ev;
				myimage.style.left = e.clientX - oX + "px";
				myimage.style.top = e.clientY - oY + "px";
			}
			//当鼠标按键抬起，清除移动事件
			document.onmouseup = function() {
				document.onmousemove = null;
				document.onmouseup = null;
			}
		}

	}
}
export default previewImg